import {Farm} from '@/common/interface/farm.data.model';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from 'environments/environment';
import {ToastrService} from 'ngx-toastr';
import {catchError, Observable, throwError} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FarmService {
    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private toastr: ToastrService
    ) {}
    private apiUrl = environment.apiUrl;
    addFarm(farm: Farm[]): Observable<any> {
        return this.httpClient
            .post(`${this.apiUrl}/Farms/AddFarms`, farm)
            .pipe();
    }
    addFarmHouseSensor(farmsensors: any): Observable<any> {
        return this.httpClient
            .post(`${this.apiUrl}/Farms/AddFarmHouseSensor`, farmsensors)
            .pipe();
    }
    getFarmDashboardList(userId: number): Observable<Farm[]> {
        return this.httpClient.get<Farm[]>(
            `${this.apiUrl}/Farms/GetDashboardFarmList?userId=${userId}`
        );
    }
    getFarmList(userId: number, placementId?: number): Observable<any> {
        const url =
            placementId !== undefined
                ? `${this.apiUrl}/Farms/GetFarmList?userId=${userId}&placementId=${placementId}`
                : `${this.apiUrl}/Farms/GetFarmList?userId=${userId}`;
        return this.httpClient.get(url).pipe();
    }
    getFarmHouseList(farmId: number, placementId?: number): Observable<any> {
        const url =
            placementId !== undefined
                ? `${this.apiUrl}/Farms/GetFarmHouseList?farmId=${farmId}&placementId=${placementId}`
                : `${this.apiUrl}/Farms/GetFarmHouseList?farmId=${farmId}`;

        return this.httpClient.get<any[]>(url).pipe();
    }
    getSensorsList(): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/MasterSensor/GetMasterSensorList`)
            .pipe();
    }
    getFarmSensorsListById(farmId: any): Observable<any> {
        return this.httpClient
            .get(
                `${this.apiUrl}/Farms/GetFarmhouseSensorsListBypartitionId?partitionId=${farmId}`
            )
            .pipe();
    }
    getFarmHousePartitionList(
        farmhouseId: number,
        placementId?: number
    ): Observable<any> {
        const url =
            placementId !== undefined
                ? `${this.apiUrl}/Farms/GetFarmHousePartitionList?farmhouseId=${farmhouseId}&placementId=${placementId}`
                : `${this.apiUrl}/Farms/GetFarmHousePartitionList?farmhouseId=${farmhouseId}`;

        return this.httpClient.get<any[]>(url).pipe();
    }
    getFarmDetail(farmId: number): Observable<any> {
        return this.httpClient
            .get(`${this.apiUrl}/Farms/GetFarmById?farmId=${farmId}`)
            .pipe();
    }
    updaeFarmDetail(farm: Farm[]): Observable<any> {
        return this.httpClient
            .post(`${this.apiUrl}/Farms/UpdateFarm`, farm)
            .pipe();
    }
    updateSensorStatus(payload: any) {
    return this.httpClient.post(
        `${this.apiUrl}/Farms/ToggleSensorStatus?id=${payload.id}&isEnabled=${payload.isEnabled}`,
        {}
    );
}
    // Handle Errors
}
